<template>
  <div class="topbar-item">
    <div
      class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
      id="kt_quick_user_toggle"
    >
      <span class="symbol user-logo symbol-35 symbol-light-success">
        <!-- <img  alt="Pic" :src="picture" /> -->
         <el-image class="symbol-img" fit="fill" :src="picture">
              <div slot="error" class="image-slot">
                {{shortName}}
              </div>
            </el-image>
        <!-- <el-image v-if="true"  :src="picture" fit="fill">
          <template slot="error">
            <div class="image-slot" style="background-color: #23B9FF;width: 40px;height: 40px;line-height: 40px;text-align: center;border-radius:50%;">
              <img src="/media/icon/user-icon.png" alt="">
            </div>
          </template>
        </el-image> -->
        <span v-if="false" class="symbol-label font-size-h5 font-weight-bold">
          S
        </span>
      </span>
    </div>

    <div
      id="kt_quick_user"
      ref="kt_quick_user"
      class="offcanvas offcanvas-right p-10"
    >
      <!--begin::Header-->
      <div
        class="offcanvas-header d-flex align-items-center justify-content-between pb-5"
      >
      <div></div>
        <!-- <h3 class="font-weight-bold m-0">
          User Profile
          <small class="text-muted font-size-sm ml-2">12 messages</small>
        </h3> -->
        <a
          href="#"
          class="btn btn-xs btn-icon btn-light btn-hover-primary"
          id="kt_quick_user_close"
        >
          <i class="ki ki-close icon-xs text-muted"></i>
        </a>
      </div>
      <!--end::Header-->

      <!--begin::Content-->
      <perfect-scrollbar
        class="offcanvas-content pr-5 mr-n5 scroll"
        style="max-height: 90vh; position: relative;"
      >
        <!--begin::Header-->
        <div class="d-flex align-items-center mt-5">
          <div class=" mr-5">
            <!-- <img class="symbol-label" :src="picture" alt="" /> -->
            <el-image class="symbol-label" :src="picture">
              <div slot="error" class="image-slot">
                {{shortName}}
              </div>
            </el-image>
            <!-- <i class="symbol-badge bg-success"></i> -->
          </div>
          <div class="d-flex flex-column">
            <a
              href="#"
              class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
            >{{currentUser.realName}}
            </a>
            <div class="text-muted mt-1">{{currentUser.roleName}}</div>
            <div class="text-muted mt-1">{{currentUser.orgName_Short}}</div>
           
            <button class="btn btn-light-primary btn-bold" @click="onLogout">
              退出登录
            </button>
          </div>
        </div>
      </perfect-scrollbar>
      <!--end::Content-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.symbol-label{
  height: 80px;
    width: 80px;
    border-radius: 12px;
    text-align: center;
  ::v-deep .image-slot{
    background-color: #409EFF;
    color: #FFF;
    font-size: 16px;
    line-height: 80px;
    // width: 80;
  }
}
.symbol-img{
  ::v-deep .image-slot{
    background-color: #409EFF;
    color: #FFF;
    font-size: 14px;
    line-height: 40px;
    // width: 80;
  }
}

#kt_quick_user {
  overflow: hidden;
}
.user-logo{
  padding-top: 6px;
}
.user-logo .el-image {
  width: 40px;
  height: 40px;
  border-radius:50%;
}
.image-slot img {
  width: 20px;
  height: 20px;
  
}
</style>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";
import { mapGetters } from "vuex";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";

export default {
  name: "KTQuickUser",
  data() {
    return {
      shortName:"",
      list: [
        {
          title: "Another purpose persuade",
          desc: "Due in 2 Days",
          alt: "+28%",
          svg: "media/svg/icons/Home/Library.svg",
          type: "warning"
        },
        {
          title: "Would be to people",
          desc: "Due in 2 Days",
          alt: "+50%",
          svg: "media/svg/icons/Communication/Write.svg",
          type: "success"
        },
        {
          title: "Purpose would be to persuade",
          desc: "Due in 2 Days",
          alt: "-27%",
          svg: "media/svg/icons/Communication/Group-chat.svg",
          type: "danger"
        },
        {
          title: "The best product",
          desc: "Due in 2 Days",
          alt: "+8%",
          svg: "media/svg/icons/General/Attachment2.svg",
          type: "info"
        }
      ]
    };
  },
  mounted() {
    // Init Quick User Panel
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
    // console.log(this.pageTitle)
  },
  created(){
//  console.log(this.currentUser)

 var disName =this.currentUser.realName;
    var disLength = disName.length;
    this.shortName = disName.substring(disLength-2,disLength);
  },
  methods: {
    onLogout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    }
  },
  computed: {...mapGetters([
      "currentUser"
    ]),
    picture() {
      return this.currentUser.photo;
    }
  }
};
</script>
